import { ChangeEvent, ReactElement } from 'react'
import { H3 } from '../../../../typography'
import { colors } from '../../../../const/theme'
import { TestWrapper } from '../subcomponents'
import { Question } from '../../../../redux/test/type'
import Form from 'react-bootstrap/esm/Form'
import { useDispatch } from 'react-redux'
import { updateAnswerForQuestion } from '../../../../redux/test/action'

interface ObjectTiveTestProps {
  question: Question
}

const DescriptiveTest = ({ question }: ObjectTiveTestProps): ReactElement => {
  const dispatch = useDispatch()

  return (
    <TestWrapper>
      <H3
        dangerouslySetInnerHTML={{ __html: question?.questionContent }}
        color={colors.black}
      />
      <Form>
        <Form.Group controlId={question.id}>
          <Form.Control
            as="textarea"
            rows={6}
            value={question?.answer || ''}
            onChange={(event: ChangeEvent<HTMLTextAreaElement>) =>
              dispatch(
                updateAnswerForQuestion({
                  id: question?.id,
                  selectedAnswer: event.target.value
                })
              )
            }
          />
        </Form.Group>
      </Form>
    </TestWrapper>
  )
}

export default DescriptiveTest
